var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var OtherSheetIcon = function (_a) {
    var width = _a.width, height = _a.height;
    return (_jsx("svg", __assign({ width: width, height: height, viewBox: "0 0 17 16", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M11.1668 0H5.8335C5.10016 0 4.50016 0.6 4.50016 1.33333V12C4.50016 12.7333 5.10016 13.3333 5.8335 13.3333H13.8335C14.5668 13.3333 15.1668 12.7333 15.1668 12V4L11.1668 0ZM13.8335 12H5.8335V1.33333H10.5002V4.66667H13.8335V12ZM3.16683 2.66667V14.6667H13.8335V16H3.16683C2.4335 16 1.8335 15.4 1.8335 14.6667V2.66667H3.16683ZM7.16683 6.66667V8H12.5002V6.66667H7.16683ZM7.16683 9.33333V10.6667H10.5002V9.33333H7.16683Z", fill: "#6366F1" }) })));
};
export default OtherSheetIcon;
